import React from 'react'

import { Flex } from 'mds-web-ui'
import styled from 'styled-components'
import { border, layout } from 'styled-system'

const Hr = styled('hr')(
  {
    border: 'none',
    height: 1,
    margin: 0,
    borderTop: '2px solid'
  },
  layout,
  border
)

export const Spacer = ({ width = '100%', color = '#EDEEF0', ...props }) => {
  return (
    <Flex width="100%" {...props} alignItems="center" justifyContent="center">
      <Hr borderColor={color} width={width} />
    </Flex>
  )
}
